// extracted by mini-css-extract-plugin
module.exports = {"webPImageWrapper":"Bitmoji3DImage_webPImageWrapper___Ve_9","avatarImageStyle":"Bitmoji3DImage_avatarImageStyle__3A2Bz"};